<template>
  <div class="ed-modal__mask" v-if="loading">
    <i class="loader"></i>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    /**
     * The name of the component.
     */
    name: 'loading',

    /**
     * The computed properties for the component.
     */
    computed: {
      ...mapState('application', {
        loading: state => state.loading,
      }),
    },
  };
</script>



// WEBPACK FOOTER //
// Loading.vue?598b465c